// src/config.js

const config = {
    development: {
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://localhost:8443",
      APP_NAME: process.env.REACT_APP_APP_NAME || "MyReactAppDev",
      REACT_APP_WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 'wss://localhost:8443/websocket',

    },
    production: {
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://ezzdesk.com:8443",
      APP_NAME: process.env.REACT_APP_APP_NAME || "MyReactApp",
      REACT_APP_WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL || 'wss://ezzdesk.com:8443/websocket',
    },
  };
  
  const currentEnv = process.env.NODE_ENV || "development";
  
  export default config[currentEnv];
  